import React from 'react';
import {useDispatch} from 'react-redux';
import parse from 'html-react-parser';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {__} from '~/shared/src/utilities/messageCatalog';

import {AppDispatch} from '~/frontend/src/store';
import closePanel from '~/frontend/src/actions/panelManager/closePanel';
import hideDeleteSuccessDialog from '~/frontend/src/actions/panelManager/hideConfirmCloseDialog'

const defaultProps = {
    visible: false as boolean
}
type DefaultProps = typeof defaultProps;

type Props = {
    panelKey : string;
};

//type ComponentProps = Partial<DefaultProps> & Props;
type AllProps = DefaultProps & Props;

/**
 * Confirm close dialog
 * @return {JSX.Element}
 * @constructor
 */
const DeleteSuccessDialog = ( props : AllProps ) => {

    const {
              panelKey,
              visible
          }                      = props,
          dispatch : AppDispatch = useDispatch(),
          footerButtons          = [] as JSX.Element[];

    footerButtons.push( <Button
        key="okButton"
        label={__( 'YN.base.common.ok' )}
        className="p-button-secondary p-button-outlined"
        onClick={() => {
            dispatch( hideDeleteSuccessDialog( panelKey ) );
            void dispatch( closePanel( panelKey ) );
        }}
    /> );

    return <Dialog
        header={__( 'YN.base.panel.deleteSuccess.title' )}
        footer={<div>
            {footerButtons}
        </div>}
        position="top"
        maskClassName="yn-dialog-panel-modal"
        appendTo="self"
        visible={visible}
        closable={false}
        className="yn-info-dialog"
        onHide={() => {
        }}
        style={{ width: 'auto', maxWidth: '80%' }}
    >
        <p>{parse( __( 'YN.base.panel.deleteSuccess.text' ) )}</p>
    </Dialog>;
}

DeleteSuccessDialog.defaultProps = defaultProps;

export default DeleteSuccessDialog;
